const addLinkIntoClipboard = () => {
    const selection = window.getSelection();
    const pagelink = `<br /><br /> по материалам сайта ${document.location.href}`;
    const newdiv = document.createElement('div');

    newdiv.style.position = 'absolute';
    newdiv.style.left = '-99999px';
    newdiv.innerHTML = selection + pagelink;

    document.body.appendChild(newdiv);
    selection.selectAllChildren(newdiv);

    window.setTimeout(() => document.body.removeChild(newdiv), 100);
};

document.addEventListener('copy', addLinkIntoClipboard);
